/**
 * Updates the recently viewed products in localStorage.
 *
 * Breakz: gated behind the "Funksjonelle" category. Not pedantry:
 * ekomlov § 3-15 speaks of "informasjonskapsler og lignende teknologi",
 * and localStorage is exactly that additional technology. Recently
 * viewed is a convenience, not a service the person asked for, so it
 * does not fall under the "strictly necessary" exemption.
 *
 * Fails closed: no BreakzConsent means no record. If the consent script
 * failed to load, we lose a convenience, not compliance.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Whether the visitor allowed the "preferences" consent category.
   * @returns {boolean}
   */
  static #allowed() {
    const consent = /** @type {any} */ (window).BreakzConsent;
    return !!(consent && consent.allows('preferences'));
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    if (!RecentlyViewed.#allowed()) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    if (!RecentlyViewed.#allowed()) return [];
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}

